<template>
  <div class="complaint-container">
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="类型：">
          <el-select 
            v-model="queryParams.type" 
            placeholder="请选择类型"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="服务质量" value="服务质量"></el-option>
            <el-option label="环境卫生" value="环境卫生"></el-option>
            <el-option label="设备设施" value="设备设施"></el-option>
            <el-option label="安全管理" value="安全管理"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态：">
          <el-select 
            v-model="queryParams.status" 
            placeholder="请选择状态"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="待处理" value="待处理"></el-option>
            <el-option label="处理中" value="处理中"></el-option>
            <el-option label="已解决" value="已解决"></el-option>
            <el-option label="已撤销" value="已撤销"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            新建投诉
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-chat-line-round"></i>
          投诉建议管理
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索..."
            prefix-icon="el-icon-search"
            style="width: 200px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
        </div>
      </div>
      
      <el-table
        ref="complaintTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        >
        <!-- 序号列 -->
        <el-table-column 
          label="序号" 
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <span class="serial-number">
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 类型 -->
        <el-table-column 
          prop="type" 
          label="类型" 
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getTypeTagType(row.type)"
              size="small"
            >
              {{ row.type || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 状态 -->
        <el-table-column 
          prop="status" 
          label="状态" 
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getStatusTagType(row.status)"
              size="small"
            >
              {{ getStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 联系人 -->
        <el-table-column 
          prop="contact" 
          label="联系人" 
          width="120"
          align="center"
        />
        
        <!-- 投诉内容 -->
        <el-table-column 
          prop="content" 
          label="投诉内容" 
          min-width="250"
          show-overflow-tooltip
        />
        
        <!-- 创建时间 -->
        <el-table-column 
          prop="createTime" 
          label="投诉时间" 
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.createTime) }}</span>
          </template>
        </el-table-column>
         <!-- 创建时间 -->
        <el-table-column 
          prop="updateTime" 
          label="更新时间" 
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.updateTime) }}</span>
          </template>
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column 
          label="操作" 
          width="420" 
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleView(row)"
              >
                查看
              </el-button>
              
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(row)"
                :disabled="row.status === '已解决' || row.status === '已撤销'"
              >
                编辑
              </el-button>
              
              <el-button
                type="success"
                size="mini"
                icon="el-icon-check"
                @click="handleResolve(row)"
                v-if="row.status === '待处理' || row.status === '处理中'"
              >
                解决
              </el-button>
              
              <el-button
                type="info"
                size="mini"
                icon="el-icon-close"
                @click="handleClose(row)"
                v-if="row.status !== '已撤销'"
              >
                撤销
              </el-button>
              
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(row)"
              >
                办结
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <PropertyComplaintDialog
      :visible="dialogVisible"
      :form-data="currentFormData"
      :is-edit="isEditMode"
      @close="handleDialogClose"
      @save="handleSave"
    />
  </div>
</template>

<script>
import propertyComplaintApi from '../api/propertyComplaint.js'
import PropertyComplaintDialog from '../components/PropertyComplaintDialog.vue'

export default {
  name: "PropertyComplaintList",
  components: {
    PropertyComplaintDialog
  },
  
  data() {
    return {
      // 加载状态
      loading: false,
      
      // 数据
      originalData: [],
      tableData: [],
      filteredData: [],
      total: 0,
      
      // 快速搜索
      quickSearch: '',
      
      // 分页参数
      pageIndex: 1,
      pageSize: 10,
      
      // 查询参数
      queryParams: {
        type: '',
        status: ''
      },
      
      // 对话框相关
      dialogVisible: false,
      isEditMode: false,
      currentFormData: {},
      
      // 表格高度
      tableHeight: 500,
      
      // 搜索防抖
      searchTimer: null
    }
  },
  
  created() {
    this.getProfile();
  },
  
  methods: {
    /**
     * 获取投诉建议列表
     */
    getProfile() {
      var self = this;
      this.loading = true;
      
      propertyComplaintApi.getAllPropertyComplaints().then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.originalData = response.data.data || [];
          self.filteredData = response.data.data || [];
          self.total = self.originalData.length;
          
          self.applyFilter();
          console.log('已加载 ' + self.originalData.length + ' 条投诉数据');
        } else {
          self.$message.error('获取投诉建议列表失败');
          self.originalData = [];
          self.filteredData = [];
          self.total = 0;
          self.tableData = [];
        }
      }).catch(function(error) {
        console.error('获取投诉建议列表失败:', error);
        self.$message.error('加载失败，请检查网络连接');
        self.originalData = [];
        self.filteredData = [];
        self.total = 0;
        self.tableData = [];
      }).finally(function() {
        self.loading = false;
      });
    },
    
    /**
     * 应用分页
     */
    applyPagination() {
      var start = (this.pageIndex - 1) * this.pageSize;
      var end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    
    /**
     * 应用筛选
     */
    applyFilter() {
      var filtered = this.originalData.slice();
      
      // 应用查询条件
      if (this.queryParams.type) {
        filtered = filtered.filter(function(item) {
          return item.type === this.queryParams.type;
        }.bind(this));
      }
      
      if (this.queryParams.status) {
        filtered = filtered.filter(function(item) {
          return item.status === this.queryParams.status;
        }.bind(this));
      }
      
      // 快速搜索
      if (this.quickSearch && this.quickSearch.trim()) {
        var search = this.quickSearch.trim().toLowerCase();
        filtered = filtered.filter(function(item) {
          return (
            (item.contact && item.contact.toLowerCase().includes(search)) ||
            (item.content && item.content.toLowerCase().includes(search))
          );
        });
      }
      
      // 按创建时间倒序排序
      filtered.sort(function(a, b) {
        return new Date(b.createTime) - new Date(a.createTime);
      });
      
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.applyFilter();
    },
    
    /**
     * 处理快速搜索（防抖）
     */
    handleQuickSearch() {
      var self = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function() {
        self.applyFilter();
      }, 300);
    },
    
    /**
     * 处理重置
     */
    handleReset() {
      this.queryParams = {
        type: '',
        status: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.applyFilter();
    },
    
    /**
     * 处理添加
     */
    handleAdd() {
      this.currentFormData = {
        type: '服务质量',
        content: '',
        contact: '',
        status: '待处理'
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },
    
    /**
     * 处理编辑
     */
    handleEdit(row) {
      this.currentFormData = {
        id: row.id,
        type: row.type,
        content: row.content,
        contact: row.contact,
        status: row.status
      };
      this.isEditMode = true;
      this.dialogVisible = true;
    },
    
    /**
     * 处理查看
     */
    handleView(row) {
      this.$alert(
        `<div style="line-height: 1.8;">
          <p><strong>类型：</strong>${row.type || '-'}</p>
          <p><strong>状态：</strong><span style="color: ${this.getStatusColor(row.status)}">${this.getStatusLabel(row.status)}</span></p>
          <p><strong>联系人：</strong>${row.contact || '-'}</p>
          <p><strong>投诉内容：</strong><div style="margin-top: 5px; padding: 10px; background: #f5f7fa; border-radius: 4px;">${row.content || '-'}</div></p>
          <p><strong>投诉时间：</strong>${this.formatDate(row.createTime)}</p>
          <p><strong>更新时间：</strong>${this.formatDate(row.updateTime)}</p>
        </div>`,
        '投诉建议详情',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭',
          customClass: 'complaint-detail-dialog'
        }
      );
    },
    
    /**
     * 处理解决
     */
    handleResolve(row) {
      var self = this;
      this.$confirm('确定要标记为"已解决"吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyComplaintApi.resolveComplaint(row.id);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('操作成功');
          self.getProfile();
        } else {
          self.$message.error('操作失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('操作失败:', error);
          self.$message.error('操作失败，请重试');
        }
      });
    },
    
    /**
     * 处理撤销
     */
    handleClose(row) {
      var self = this;
      var pojo;
      this.$confirm('确定要撤销该投诉建议吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        pojo = {
            id:row.id,
            status:'4'
        }
        return propertyComplaintApi.updatePropertyComplaint(pojo);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('撤销成功');
          self.getProfile();
        } else {
          self.$message.error('撤销失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('撤销失败:', error);
          self.$message.error('撤销失败，请重试');
        }
      });
    },
    
    /**
     * 处理办结
     */
    handleDelete(row) {
      var self = this;
      var pojo;
      this.$confirm('确定要办结该投诉建议吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        pojo={
            id:row.id,
            status:'3'
        }
        return propertyComplaintApi.updatePropertyComplaint(pojo);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('办结成功');
          self.getProfile();
        } else {
          self.$message.error('办结失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('办结失败:', error);
          self.$message.error('办结失败，请重试');
        }
      });
    },
    
    /**
     * 处理分页大小变化
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理页码变化
     */
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    
    /**
     * 处理对话框撤销
     */
    handleDialogClose() {
      this.dialogVisible = false;
      this.currentFormData = {};
    },
    
    /**
     * 处理保存
     */
    handleSave(formData) {
      var self = this;
      var promise;
      
      if (this.isEditMode) {
        promise = propertyComplaintApi.updatePropertyComplaint(formData);
      } else {
        promise = propertyComplaintApi.addComplaint(formData);
      }
      
      promise.then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.$message.success(self.isEditMode ? '更新成功' : '新增成功');
          self.dialogVisible = false;
          self.currentFormData = {};
          self.getProfile();
        } else {
          var message = (response && response.data && response.data.message) || '保存失败';
          self.$message.error(message);
        }
      }).catch(function(error) {
        console.error('保存失败:', error);
        self.$message.error('保存失败，请重试');
      });
    },
    
    /**
     * 格式化日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        var date = new Date(dateStr);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateStr;
      }
    },
    
    /**
     * 获取类型标签样式
     */
    getTypeTagType(type) {
      const map = {
        '服务质量': 'danger',
        '环境卫生': 'warning',
        '设备设施': 'primary',
        '安全管理': 'success',
        '其他': 'info'
      };
      return map[type] || 'info';
    },
    
        /**
     * 获取状态标签
     */
    getStatusLabel(statusCode) {
      const statusMap = {
        1: '待受理',
        2: '处理中',
        3: '已办结',
        4: '已撤销',
      };
      return statusMap[statusCode] || '未知状态';
    },
    
    /**
     * 获取状态标签样式
     */
    getStatusTagType(statusCode) {
      const map = {
        1: 'warning',    // 待处理 - 黄色
        2: 'primary',    // 派单中 - 蓝色
        3: 'info',       // 维修中 - 青色
        4: 'success',    // 已完成 - 绿色
      };
      return map[statusCode] || 'info';
    },
    
    /**
     * 获取状态颜色
     */
    getStatusColor(statusCode) {
      const map = {
        1: '#e6a23c',    // 待处理 - 黄色
        2: '#409eff',    // 派单中 - 蓝色
        3: '#909399',    // 维修中 - 灰色
        4: '#67c23a',    // 已完成 - 绿色
      };
      return map[statusCode] || '#909399';
    }
  }
}
</script>

<style scoped>
.complaint-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(90vh - 84px);
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  border: none;
}

.search-form {
  margin-bottom: -10px;
}

.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.footer-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.pagination-container {
  text-align: right;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.serial-number {
  color: #909399;
  font-weight: 500;
}

.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}
</style>

<style>
/* 投诉详情对话框样式 */
.complaint-detail-dialog {
  width: 500px;
}

.complaint-detail-dialog .el-message-box__content {
  max-height: 400px;
  overflow-y: auto;
}
</style>